import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full h-[100svh] flex flex-col justify-end overflow-hidden bg-cream" data-id="element-46">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-47">
        <img src="https://cdn.magicpatterns.com/uploads/eBXVekwbfGYfT33DFrdhDi/1-Lanoma-Court-Wheelers-Hill.png.png" alt="1 Lanoma Court, Wheelers Hill - Watercolour Illustration" className="w-full h-full object-cover object-center" loading="eager" fetchPriority="high" decoding="async" width="2272" height="1480" data-id="element-48" />
        {/* Soft cream gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-cream via-cream/60 to-cream/10" data-id="element-49" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-16 md:pb-24 flex flex-col items-center text-center" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: 'easeOut',
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-51">
          {/* Quiet Tagline */}
          <span className="text-[10px] tracking-[0.3em] uppercase text-ink-soft mb-5" data-id="element-52">
            Auction · 20 June
          </span>

          {/* Headline */}
          <h1 className="text-[clamp(2.5rem,6vw,5rem)] leading-[0.9] mb-5 text-charcoal" data-id="element-53">
            RENOVATED MASTERPIECE
          </h1>

          {/* Address */}
          <p className="text-ink font-serif italic text-lg md:text-xl tracking-wide" data-id="element-54">
            1 Lanoma Court, Wheelers Hill
          </p>
        </motion.div>
      </div>
    </section>;
}